import { contact } from "@/config/content";
import { MessageCircle } from "lucide-react";

// Renders only when a valid WhatsApp number is configured.
export const WhatsAppButton = () => {
  if (!contact.whatsapp) return null;
  const href = `https://wa.me/${contact.whatsapp}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label="Kontakt über WhatsApp aufnehmen"
      className="fixed bottom-5 right-5 z-40 inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_12px_40px_rgb(0,0,0,0.2)] hover:-translate-y-1 transition-transform duration-200"
    >
      <MessageCircle className="w-7 h-7" />
    </a>
  );
};
